import React from 'react';

//TODO: Mergear GenericModal en webcore
import GenericModal from '../../../Packages/SharedComponents/Com.Gyf.WebCore.GenericModal';

import { GenericIconButton, LinkButton } from 'com-gyf-webcore-userinterfacecomponents';

const HistoryMaxScreen = (props) => {
    let oHistory = props.historial.map(function (row) {
        return (
            <li className="list-group-item">
                <div className="row">
                    <div className="col-xs-12">
                        <p className="inlineListItem">...en </p>
                        <LinkButton onClick={() => props.selectHistorial(row.producto.Id, row.categoria.Id, row.programa.Id)}
                            text={row.producto.Descripcion + " > " + row.categoria.Descripcion + " > " + row.programa.Descripcion} />
                        <span className="ti-close pull-right top-separator-xxs clickable"
                            onClick={() => props.deleteHistorial(row.id)}
                            title="Quitar estos cambios." />
                    </div>
                </div>
            </li>
        );
    });

    return (
        <ul className="list-group no-margin">
            {oHistory}
        </ul>
    );
}

export default HistoryMaxScreen;